export default __webpack_public_path__ + "static/media/classifier-black.d6f47777.svg";